import { GET_ATOS_LOGIN_DATA } from 'store/constants'

export function getAtosLoginData(values) {
    return {
        type: GET_ATOS_LOGIN_DATA,
        payload: values,
    }
}